<div #target>
  <ng-template appWidgetEditor></ng-template>
</div>